import React, {useEffect, useState} from 'react'

import {DPFullNode} from 'types/DPTypes'
import css from './AdminTools.module.scss'
import {fromModule} from 'util/styler/Styler'
import {isLocalstorageAvailable} from 'util/useLocalStorage'
import {useMediaQuery} from 'util/mediaquery'

const styles = fromModule(css)

const developmentHosts: Record<string, string> = {
	'imec-int.com': 'int.imec.dev',
	'imec.be': 'be.imec.dev',
	'imeciclink.com': 'iclink.imec.dev',
	'imechyperspectral.com': 'hyperspectral.imec.dev'
}

export const useIsAdmin = () => {
	const [isAdmin, setIsAdmin] = useState(false)

	useEffect(() => {
		if (process.env.NODE_ENV !== 'production') {
			setIsAdmin(true)
			return
		}

		if (!isLocalstorageAvailable()) return

		if (!localStorage.admin_enabled) return
		if (!localStorage.admin_refreshed) return

		const validUntil =
			parseInt(localStorage.admin_refreshed, 10) + 1000 * 60 * 60 * 24 * 14
		if (Date.now() > validUntil) return

		setIsAdmin(true)
	}, [])
	return isAdmin
}

export const AdminTools: React.FC<{node: DPFullNode}> = ({node}) => {
	const isAdmin = useIsAdmin()
	const isDesktop = useMediaQuery('(min-width: 1200px)')

	if (!isAdmin) return null
	if (!node) return null
	if (!isDesktop) return null

	const location = typeof window !== 'undefined' ? window.location : null
	const developmentHost =
		location && developmentHosts[location.hostname.replace(/^www\./, '')]
	const developmentUrl =
		developmentHost && location
			? `https://${developmentHost}${location.pathname}${location.search}${location.hash}`
			: null

	return (
		<div className={styles.tools()}>
			<a
				href={`${process.env.NEXT_PUBLIC_DRUPAL_URL}/nl/node/${node.node_id}/edit`}
				target="_blank"
				className={styles.tools.button()}
			>
				Edit
			</a>
			<a
				href={`${process.env.NEXT_PUBLIC_DRUPAL_URL}/api/page?route=/${node.langcode}/node/${node.node_id}`}
				target="_blank"
				className={styles.tools.button()}
			>
				JSON
			</a>
			<a
				href={`${process.env.NEXT_PUBLIC_DRUPAL_URL}/api/search-data/${node.langcode}/${node.node_id}`}
				target="_blank"
				className={styles.tools.button()}
			>
				Search Data
			</a>
			{developmentUrl && (
				<a
					href={developmentUrl}
					target="_blank"
					rel="noopener noreferrer"
					className={styles.tools.button()}
				>
					Open on rebuild
				</a>
			)}
		</div>
	)
}
